import { BenefitStates } from "v2/infrastructure/Benefits/types/BenefitStates";
import { BenefitType } from "v2/infrastructure/Benefits/types/BenefitTypes";
import { Properties } from "v2/infrastructure/common/types/FunctionPropertiesType";

export default class Benefit {
  type: BenefitType;

  benefit: string;

  state: BenefitStates;

  tags: string[];

  constructor({
    type = BenefitType.CORE,
    benefit = "",
    state = BenefitStates.INACTIVE,
    tags = [],
  }: Properties<Benefit>) {
    this.type = type;
    this.benefit = benefit;
    this.state = state;
    this.tags = tags;
  }
}
